import {IFuneralPlanGroup} from "@/shared/domain/funeral-plan-group.model";
import {BaseService} from "@/services/BaseService";

class FuneralPlanGroupService extends BaseService<IFuneralPlanGroup>{
  public entityUrl = "funeral-plan-groups"
}

export default new FuneralPlanGroupService();
